import React from 'react';

const CustomerSupport = () => {

  return (
    <>
      <div className='faq-page inner-page'>
        <div className='container'>
          <h1 className='policies-title'>Customer Support</h1>
          <div className="policies-date">Last updated on: 20 June 2022</div>
          <div className='admin-content-area'>

          </div>
        </div>
      </div>
    </>
  )
}

export default CustomerSupport;